import React from 'react'
import PropTypes from 'prop-types'

import Col from 'component/utils/Col'
import Row from 'component/utils/Row'

const Title = ({
  handleSideFilterMenuCollapseChange = () => {},
  sideFilterVisible = false,
  translate = () => {},
}) => (
  <Row>
    {sideFilterVisible && (
      <Col xs={3}>
        <p />
      </Col>
    )}
    <Col xs={sideFilterVisible ? 9 : 12}>
      <button
        className={`filter-button ${
          sideFilterVisible ? '' : 'margin-left'
        } title`}
        onClick={() => handleSideFilterMenuCollapseChange(!sideFilterVisible)}
      >
        <i
          className={`glyph glyph-double-arrow-${
            sideFilterVisible ? 'left' : 'right'
          } glyph-grey icon-size`}
        />
        {translate('mobile.filters')}
      </button>
    </Col>
  </Row>
)

Title.propTypes = {
  handleSideFilterMenuCollapseChange: PropTypes.func,
  sideFilterVisible: PropTypes.bool,
  translate: PropTypes.func,
}

export default Title
